import React from "react";
import { Checkbox } from "../component/ui/CheckBox";
import { Label } from "../component/ui/Label";
import { cn } from "../lib/utils";

type ICustomCheckbox = {
  id: string;
  label: string;
  description?: string;
  defaultChecked?: boolean;
  className?: string;
  onChange?: (checked: boolean) => void;
};

export const CustomCheckbox: React.FC<ICustomCheckbox> = ({
  id,
  label,
  description,
  defaultChecked = false,
  className,
  onChange,
}) => {
  return (
    <Label
      htmlFor={id}
      className={cn(
        "hover:bg-accent/50 flex items-start gap-3 rounded-lg border p-3",
        "has-[[aria-checked=true]]:border-primary-600 has-[[aria-checked=true]]:bg-primary-100/50",
        "dark:has-[[aria-checked=true]]:border-primary-900 dark:has-[[aria-checked=true]]:bg-blue-950",
        className
      )}
    >
      <Checkbox
        id={id}
        onCheckedChange={onChange}
        defaultChecked={defaultChecked}
        className={cn(
          "data-[state=checked]:border-primary-600 data-[state=checked]:bg-primary-500 data-[state=checked]:text-white",
          "dark:data-[state=checked]:border-primary-700 dark:data-[state=checked]:bg-primary-700"
        )}
      />
      <div className="grid gap-1.5 font-normal">
        <p className="text-sm leading-none font-medium mb-0">{label}</p>
        {description && (
          <p className="text-muted-foreground text-sm">{description}</p>
        )}
      </div>
    </Label>
  );
};
